import ApiService from "./api.service";

const KpiDashboardService = {
    async fetchWidgets(params) {
        try {
            const query = new URLSearchParams(params).toString();
            const url = query
                ? `kpi-dashboard/widgets?${query}`
                : `kpi-dashboard/widgets`;

            const response = await ApiService.get(url);

            return {
                widgets: {
                    ...response.data.widgets,
                    ...(response.data?.dealer_list && {
                        dealer_list_widget: {
                            signature: "dealer_list_widget",
                            ...response.data.dealer_list,
                        },
                    }),
                    ...(response.data?.wholesaler_list && {
                        wholesaler_list_widget: {
                            signature: "wholesaler_list_widget",
                            ...response.data.wholesaler_list,
                        },
                    }),
                },
            };
        } catch (e) {
            return e.response;
        }
    },

    async fetchCustomerDetails(userId, params = {}) {
        try {
            const searchParams =
                params instanceof URLSearchParams
                    ? params
                    : new URLSearchParams(params);

            if (!searchParams.has("per_page")) {
                searchParams.set("per_page", 20);
            }
            if (!searchParams.has("sort_by")) {
                searchParams.set("sort_by", "date");
            }
            if (!searchParams.has("sort_order")) {
                searchParams.set("sort_order", "desc");
            }

            const query = searchParams.toString();
            const url = query
                ? `kpi-dashboard/customer_details/${userId}?${query}`
                : `kpi-dashboard/customer_details/${userId}`;

            const response = await ApiService.get(url);
            return response.data;
        } catch (e) {
            console.error("Error fetching customer details:", e);
            return null;
        }
    },

    async fetchCustomers(params) {
        try {
            const query = new URLSearchParams(params).toString();
            const url = query
                ? `kpi-dashboard/customers?${query}`
                : `kpi-dashboard/customers`;

            const response = await ApiService.get(url);
            return response.data;
        } catch (e) {
            console.error("Error fetching customers:", e);
            return null;
        }
    }
};

export { KpiDashboardService };

